import CircleType from 'circletype';

$(window).on('load', function () {
  try {
    if ($('.arc-title').length) {
      new CircleType(document.querySelector('.arc-title h2')).radius(1305);
    }

    var arcText = $('.dealer-locator h2');
    if (arcText.length) {
      var charCount = arcText.find('span').length;
      var middleNum = charCount / 2 + (charCount % 2);

      arcText.find('span').each(function (e) {
        var mod = e % middleNum;
        var spacing = e <= middleNum ? e : middleNum - mod;
        $(this).css({
          bottom: spacing * 2 + 'px',
        });
      });
    }
  } catch (e) {
    Rollbar.error('arc-text js', e);
  }
});
